import React, { useState } from 'react';
import useDeliveryPickupAxios, { useDeliveryPickupFormData } from '../utils/axios';
import QRCode from "qrcode";
import { useDispatch } from 'react-redux';
import { setErrorResponse, setFlagCode, setOrderQrResponse, setOrdersToDo, setResetResponseApi, setSaveBillReferenceResponse, setSerialNumberResponse, setTodoOrderDetails } from '../features/TodoSlice';
import { setTodoOrdersCount } from '../features/DeliveryOrdersCountSlice';
import { setSaveBillReferenceDropOffResponse } from '../features/DropOffSlice';

function useTodoApi() {

    const DeliveryPortalAxios = useDeliveryPickupAxios();
    const DeliveryPortalAxios1 = useDeliveryPickupFormData();
    const DeliveryPortalClient = DeliveryPortalAxios;
    DeliveryPortalClient.defaults.timeout = 600000;
    const DeliveryPortalClient1 = DeliveryPortalAxios1;
    DeliveryPortalClient1.defaults.timeout = 600000;

    const [qrCode, setQrCode] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [confirmMessage, setConfirmMessage] = useState("");
    const [ordersToProcess, setOrdersToProcess] = useState([]);
    const dispatch = useDispatch();

    const GetOrder = async (orderID) => {
        try {
            const response = await DeliveryPortalAxios.get("/Todo/GetOrder", {
                params: { OrderID: orderID}
            });
            if (response && response.data && response.data.payload) {
                dispatch(setTodoOrderDetails(response.data.payload))
            }
        } catch (error) {
            console.error("Error fetching orders:", error);
        }
    }

    const GetOrderQr = async (orderID) => {
        try {
            setIsLoading(true);
            const response = await DeliveryPortalAxios.get("/Todo/GetOrderQr", {
                params: { OrderID: orderID}
            });
            const qr = await QRCode.toDataURL(response.data.payload.qrCode);
            setIsLoading(false)
            setQrCode(qr);
            dispatch(setOrderQrResponse(response))
        } catch (error) {
            console.error("Error fetching orders:", error)
        }
    }

    const ConfirmOrder = async (orderID) => {
        try{
            const response = await DeliveryPortalAxios.post("/Todo/ConfirmOrder", {
                OrderID: orderID
            })
            if (response && response.data && response.data.payload) {
                setConfirmMessage({
                    title: response.data.payload.title,
                    message: response.data.payload.message
                });
            }
        } catch(error){
            console.error("Error to Confirm Order", error);
        }
    }

    const GetOrdersToProcess = async () => {
        setIsLoading(true)
        try {
            const response = await DeliveryPortalAxios.get("/Todo/GetOrdersToProcess")

            if (response && response.data.payload) {
                setOrdersToProcess(response.data.payload.orders)
                dispatch(setOrdersToDo(response.data.payload.orders))
            }
            setIsLoading(false)
        } catch (error) {
            console.error(error);
        }
    }

    const GetOrdersToProcessCount = async () => {
        try  {
            const response = await DeliveryPortalAxios.get("/Todo/GetOrdersToProcessCount")

            if (response && response.data.payload) {
                dispatch(setTodoOrdersCount(response.data.payload.count))
            }
        } catch (error) {
            console.error(error);
        }
    }

    const SetSerialNumber = async (orderID, serialNumber) => {
        try{
               const response = await DeliveryPortalAxios.post('/Todo/SetSerialNumber', {
                    orderID: orderID,
                    serialNumber: serialNumber
                })
                dispatch(setSerialNumberResponse(response));
        } catch (error) {
            console.error(error);
            dispatch(setSerialNumberResponse({
                data: {
                  flagCode: -1,
                  message: error.response?.data?.message || "An error occurred while setting the serial number.",
                },
              }));
            }
        }

    

    const SaveBillReference = async (orderID, billReference) => {
        try{
          const response = await DeliveryPortalAxios.post('/Todo/SaveBillReference', {
            orderID: orderID,
            billReference: billReference,
          },
          {
            headers: {
              'Content-Type': 'application/json', 
            },
          }
        );
            dispatch(setSaveBillReferenceResponse(response));
            dispatch(setSaveBillReferenceDropOffResponse(response));
        } catch (error) {
            console.error(error);
        }
    }

    const ResetOderPreparation = async (orderID) => {
        try {
            const response = await DeliveryPortalAxios.post('/Todo/ResetOrderPreparation', {
                orderID: orderID
            });
            return response.data.payload;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };
    
 

    return {
        GetOrder,
        GetOrderQr,
        qrCode,
        isLoading,
        ConfirmOrder,
        confirmMessage,
        GetOrdersToProcess,
        ordersToProcess,
        GetOrdersToProcessCount,
        SetSerialNumber,
        SaveBillReference,
        ResetOderPreparation
    };
}

export default useTodoApi;
